var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-main",
    { staticClass: "pa-2", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-btn",
            {
              attrs: { color: "primary", dark: "" },
              on: {
                click: function($event) {
                  _vm.dialog = true
                }
              }
            },
            [_vm._v("Add Resource")]
          ),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "600px" },
              on: {
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape"
                    ])
                  ) {
                    return null
                  }
                  _vm.dialog = false
                }
              },
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c(
                "v-card",
                { attrs: { color: "lighten-1" } },
                [
                  _c(
                    "v-toolbar",
                    [
                      _c("v-toolbar-title", [
                        _c("span", { staticClass: "headline" }, [
                          _vm._v(_vm._s(_vm.formTitle))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-spacer")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-container",
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-form",
                                {
                                  ref: "form",
                                  staticClass: "row",
                                  model: {
                                    value: _vm.valid,
                                    callback: function($$v) {
                                      _vm.valid = $$v
                                    },
                                    expression: "valid"
                                  }
                                },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "12" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          readonly: "",
                                          label: "Name",
                                          required: ""
                                        },
                                        model: {
                                          value: _vm.editedItem.name,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "name",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.name"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "12" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Qty",
                                          required: "",
                                          type: "number"
                                        },
                                        model: {
                                          value: _vm.editedItem.qty,
                                          callback: function($$v) {
                                            _vm.$set(_vm.editedItem, "qty", $$v)
                                          },
                                          expression: "editedItem.qty"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("v-select", {
                                        attrs: {
                                          items: ["qts", "gal", "lt"],
                                          "item-text": "unit",
                                          value: _vm.editedItem.unit,
                                          label: "Unit"
                                        },
                                        model: {
                                          value: _vm.editedItem.unit,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "unit",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.unit"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "12" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          items: ["Aircrafts", "Others"],
                                          "item-text": "category",
                                          "item-value": "category",
                                          value: _vm.editedItem.category,
                                          label: "Category"
                                        },
                                        model: {
                                          value: _vm.editedItem.category,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.editedItem,
                                              "category",
                                              $$v
                                            )
                                          },
                                          expression: "editedItem.category"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "blue darken-1", text: "" },
                          on: { click: _vm.close }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "blue darken-1",
                            type: "submit",
                            disabled: !_vm.valid
                          },
                          on: { click: _vm.save }
                        },
                        [_vm._v("Save")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-data-table", {
        staticClass: "elevation-1",
        attrs: {
          headers: _vm.headers,
          items: _vm.resources,
          "items-per-page": 10
        },
        scopedSlots: _vm._u([
          {
            key: "item.actions",
            fn: function(ref) {
              var item = ref.item
              return [
                _c(
                  "v-btn",
                  {
                    attrs: { icon: "", small: "" },
                    on: {
                      click: function($event) {
                        return _vm.edit(item)
                      }
                    }
                  },
                  [
                    _c("v-icon", { attrs: { center: "" } }, [
                      _vm._v("mdi-pencil")
                    ])
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }